export default __webpack_public_path__ + "static/media/dropdown-ic.b57edcbf.b57edcbf.svg";